<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38">
                mdi-chevron-left
              </v-icon>
              {{ $t("consentform.consentcr") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5 pb-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("consentform.title") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center pt-3>
                    <v-flex xs11 lg10>
                      <v-row>
                        <v-col cols="12" md="6">
                          <b class="red--text mr-1">*</b>
                          <b>{{ $t("consentform.subject") }}</b>
                          <br />
                          <v-text-field
                            outlined
                            dense
                            color="#077893"
                            v-model="Title"
                            :label="$t('consentform.speconsent')"
                            :rules="[
                              (v) => !!v || $t('consentform.sepconsent2'),
                            ]"
                          ></v-text-field>
                          <b class="red--text mr-1">*</b>
                          <b>{{ $t("consentform.exdate") }}</b>
                          <br />
                          <v-text-field
                            hide-details
                            color="#077893"
                            :label="$t('consentlist.expiration')"
                            :oninput="rulesObject.numRegex"
                            v-model="ExpirationDate"
                            :rules="[(v) => !!v || $t('consentform.exdate2')]"
                            outlined
                            dense
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <!-- <b class="red--text mr-1">*</b> -->
                          <b>{{ $t("consentform.brief") }}</b>
                          <br />
                          <v-textarea
                            hide-details
                            auto-grow
                            row-height="25"
                            outlined
                            dense
                            clearable
                            name="input-7-4"
                            :label="$t('consentform.brief')"
                            v-model="ShortConsent"
                          ></v-textarea>
                          <!-- :rules="[(v) => !!v || $t('consentform.brief2')]" -->
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="12">
                          <b class="red--text mr-1">*</b>
                          <b v-if="$t('default') === 'th'">
                            ข้อมูลที่ต้องการขอ
                          </b>
                          <b v-else>Personal Data to Request</b>
                          <v-combobox
                            hide-details
                            color="#077893"
                            v-model="addRequest"
                            :items="itemsRequest"
                            required
                            persistent-hint
                            append-icon="mdi-chip"
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                            :rules="[required]"
                          ></v-combobox>
                        </v-col>
                        <v-col cols="12" md="12">
                          <!-- <b class="red--text mr-1">*</b> -->
                          <b v-if="$t('default') === 'th'"> Tag Source </b>
                          <b v-else> Tag Source</b>
                          <v-combobox
                            hide-details
                            color="#077893"
                            v-model="addRequestTag"
                            :items="itemsRequest"
                            required
                            persistent-hint
                            append-icon="mdi-chip"
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                          ></v-combobox>
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2 pb-2>
                    <v-flex xs11 lg10 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.detail") }}</b>
                      <vue-editor
                        v-model="DetailConsent"
                        :editorToolbar="DefaultToolbar"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2 pb-2>
                    <v-flex xs11 lg10 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.agree") }}</b>
                      <vue-editor
                        v-model="RejectReason"
                        :editorToolbar="DefaultToolbar"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    mt-n5
                    pb-3
                    pa-3
                  >
                    <v-flex lg2 md2 sm2 xs2>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        @click="Fn_CreatePolicy"
                        :loading="loading"
                      >
                        {{ $t("policy.text10") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { VueEditor },
  data: function () {
    return {
      valid: true,
      ItemPolicy: [],
      Title: "",
      DetailConsent: "",
      RejectReason: "",
      ExpirationDate: "2",
      ShortConsent: "",
      ModalExpirationDate: false,
      rulesObject: {
        numRegex: "this.value = this.value.replace(/[^0-9.]|/g, '').substr()",
      },
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }, { size: 56 }, { background: [] }],
      ],
      addRequest: [],
      addRequestTag: [],
      itemsRequest: [],
      addRequestFix: "",
      addRequestFixTag: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),

    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
  },
  mounted() {},
  methods: {
    async Fn_CreatePolicy() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          AccessToken: this.$cookies.get("OneAccessToken"),
          Title: this.Title,
          DetailsConsent: this.DetailConsent,
          RejectReason: this.RejectReason,
          ExpireIn: this.ExpirationDate,
          ShortConsent: this.ShortConsent,
          Tag: this.addRequestFix,
          TagSource: this.addRequestFixTag,
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "consent/InsertDetailConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loading = false;

            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/consent-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return "";
      } else if (value.includes(" ") == true) {
        return "";
      }
      return !!value || "";
    },
    Fn_BackIndex() {
      this.$router.push("/consent-index");
    },
  },
  watch: {
    addRequest(val) {
      this.addRequestFix = val.join(", ");
    },
    addRequestTag(val) {
      this.addRequestFixTag = val.join(", ");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
